var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserThreeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 46.4521,
    cy: 46.4521,
    r: 46.4521,
    fill: "#356733"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.389 44.1412C61.794 44.1412 64.5561 41.2728 64.5561 37.7343C64.5561 34.1958 61.794 31.3274 58.389 31.3274",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2242 51.1038C62.2411 51.1767 63.252 51.3265 64.2474 51.5593C65.6304 51.8407 67.294 52.4297 67.8861 53.7192C68.264 54.5451 68.264 55.5067 67.8861 56.3346C67.2959 57.6241 65.6304 58.2112 64.2474 58.5067",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3662 44.1412C30.9612 44.1412 28.1991 41.2728 28.1991 37.7343C28.1991 34.1958 30.9612 31.3274 34.3662 31.3274",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.531 51.1038C30.5142 51.1767 29.5032 51.3265 28.5078 51.5593C27.1248 51.8407 25.4613 52.4297 24.8711 53.7192C24.4912 54.5451 24.4912 55.5067 24.8711 56.3346C25.4593 57.6241 27.1248 58.2112 28.5078 58.5067",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3676 52.4836C53.2672 52.4836 59.1616 53.5686 59.1616 57.9107C59.1616 62.2509 53.3061 63.3764 46.3676 63.3764C39.4662 63.3764 33.5737 62.2913 33.5737 57.9492C33.5737 53.6071 39.4292 52.4836 46.3676 52.4836Z",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3677 46.29C41.8174 46.29 38.1689 42.4985 38.1689 37.7677C38.1689 33.0389 41.8174 29.2474 46.3677 29.2474C50.9181 29.2474 54.5665 33.0389 54.5665 37.7677C54.5665 42.4985 50.9181 46.29 46.3677 46.29Z",
    stroke: "#356733",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserThreeCircle);
export default __webpack_public_path__ + "static/media/userThreeCircle.2254c4135c513afafdf043192ed9cd0c.svg";
export { ForwardRef as ReactComponent };